import { useTranslation } from 'react-i18next';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';

export default function EditorialPolicyPage() {
  const { t } = useTranslation();

  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main className="pt-6 pb-12">
        <div className="w-full px-4 md:px-6 lg:px-8 max-w-3xl mx-auto">
          <nav className="text-sm text-stone-500 mb-6">
            <a href="/" className="hover:text-emerald-700 transition-colors">{t('breadcrumb_home')}</a>
            <span className="mx-2">/</span>
            <span className="text-stone-700">Editorial Policy</span>
          </nav>

          <h1 className="text-3xl md:text-4xl font-bold text-stone-800 mb-6">Editorial Policy</h1>

          <p className="text-sm md:text-base text-stone-600 leading-relaxed mb-8">
            This page explains how we create, review, and maintain the content published on CSSBuyBR. We believe in transparency, accuracy, and honesty, and this policy describes the standards we follow.
          </p>

          <div className="space-y-6">
            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Our Mission</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                CSSBuyBR exists to help international buyers research products and understand the buying process more clearly. We create practical, organized guides and resources with the goal of helping users make more informed decisions. We are not a store, and we do not sell products or process payments.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Independence</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                This website is an independent resource. We are not affiliated with, endorsed by, or officially representing CSSBuy or any other platform, seller, or brand mentioned in our content. Our guides are written from a neutral, informational perspective, and we do not accept payment in exchange for favorable coverage.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Accuracy and Sourcing</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                We aim to provide accurate and up-to-date information. Where possible, our content is based on publicly available information, platform documentation, and general knowledge of the buying-agent process. However, prices, fees, seller behavior, shipping options, and policies change frequently, so we always recommend verifying current information directly before making a purchase.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Updates and Corrections</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                We regularly review our content and update it when information changes. Each article includes a last-updated date so you can see when it was last refreshed. If you notice an error or outdated information, you are welcome to contact us, and we will review and correct it where appropriate.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Affiliate and Advertising Disclosure</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                Some links on this website point to external websites. These links are provided for your convenience and research purposes. We do not guarantee the accuracy, safety, or availability of external sites, and the inclusion of a link does not necessarily imply endorsement. We do not currently operate an affiliate or paid-placement program.
              </p>
            </section>

            <section>
              <h2 className="text-xl font-bold text-stone-800 mb-3">Contact</h2>
              <p className="text-sm md:text-base text-stone-600 leading-relaxed">
                If you have questions about this editorial policy or would like to report an issue with our content, please reach out through our <a href="/contact/" className="text-emerald-700 hover:text-emerald-800 underline">contact page</a>.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}